exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.addDemand .mint-cell{height:0.48rem\n}\n.addDemand .mint-field .mint-cell-title{width:auto !important;min-width:105px\n}\n", ""]);

// exports
